import useExtraEntropy from './useExtraEntropy'

export default useExtraEntropy
